define('pwa/plugin/tickets/view/TicketsItemDialogView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Ticket item dialog view
     *
     * @class TicketsItemDialogView
     */
    return LayoutView.extend({

        template: '#tickets_item_dialog_view',

        ui: {
            qrCode: '#sb_tickets_item_qr'
        },

        onRender: function() {
            new QRCode(this.ui.qrCode[0], {
                text: "https://simplybook.me/tickets/?ticket=" + this.getOption('ticketCode'),
                width: 210,
                height: 210,
            });
        },

        serializeData: function () {
            return {
                qr_code_url: 'here code',
                ticket_code: this.getOption('ticketCode'),
                service_name: this.getOption('serviceName'),
                start_date: this.getOption('startDate'),
                start_time: this.getOption('startTime'),
                end_time: this.getOption('endTime'),
                provider_name: this.getOption('providerName'),
            };
        },
    });

});
